import React, { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";

import "./../styles/dashboard.css";
import Loading from "./Loading";
import ErrorLog from "./ErrorLog";
import { Paginate } from "../utils/Pagination";
import TransactionHistoryTab from "./TransactionHistoryTab";
import CustomerTransactionTab from "./CustomerTransactionTab";
import { renderDropdownContent } from "../utils/Miscellaneous";

const MainTabsComponent = React.memo(
  ({
    selectedCustomer,
    setSelectedCustomer,
    transactionDetails,
    transactionsLoading,
    fetchTransactions,
    fetchCustomerData,
    transactionsError,
    activeTab,
    setActiveTab,
    setSenderName,
    senderName,
    senderNames,
    flowLinkType,
  }) => {
    const navigate = useNavigate();
    const recordsPerPage = parseInt(process.env.REACT_APP_RECORDS_PER_PAGE, 10);

    const [activeChildTab, setActiveChildTab] = useState("transactionStatus");
    const [activeOutboundSubTab, setActiveOutboundSubTab] = useState("");
    const [activeSubSubTab, setActiveSubSubTab] = useState("transactionStatus");
    const [currentPage, setCurrentPage] = useState(1);
    const [messageFlowType, setMessageFlowType] = useState("");
    const [senderList, setSenderList] = useState([]);
    const [searchInput, setSearchInput] = useState("");

    const handleTabClick = useCallback(
      (tab) => {
        setActiveTab(tab);
        setActiveChildTab("transactionStatus");
        setActiveOutboundSubTab("");
        setSelectedCustomer(null);
        setMessageFlowType(tab === "outbound-tab" ? "Outbound" : "Inbound");
        setCurrentPage(1);
        setActiveSubSubTab("transactionStatus");
        setSenderList(senderNames?.senderList || []);
      },
      [setActiveTab, setSelectedCustomer, senderNames?.senderList]
    );

    const handleInboundChildTabClick = useCallback(
      (tab) => {
        setActiveChildTab(tab);
        setActiveSubSubTab("transactionStatus");

        console.log("in handleInboundChildTabClick and active tab is - ", tab);
        console.log(
          "in handleInboundChildTabClick and active sub-tab is - ",
          activeSubSubTab
        );
      },
      [activeSubSubTab]
    );

    const handleOutboundSubTabClick = useCallback(
      (subTab) => {
        setActiveOutboundSubTab(subTab);
        setActiveSubSubTab("transactionStatus");
        setSenderName(subTab);

        console.log(
          "in handleOutboundSubTabClick and active tab is - ",
          subTab
        );
        console.log(
          "in handleOutboundSubTabClick and active sub-tab is - ",
          activeSubSubTab
        );
      },
      [setSenderName, activeSubSubTab]
    );

    const handleSubSubTabClick = useCallback((subTab) => {
      setActiveSubSubTab(subTab);
    }, []);

    const fetchTransactionDetails = useCallback(() => {
      if (messageFlowType === "outbound" && senderName === "") return;

      if (
        !selectedCustomer?.customerName ||
        !selectedCustomer?.customerReferenceIdentifier
      ) {
        toast.error(
          "Please select a customer with a valid Reference-Identifier."
        );
        return;
      }

      console.log("Fetching transaction details for:", selectedCustomer);

      fetchTransactions(
        selectedCustomer.customerName,
        selectedCustomer.customerReferenceIdentifier,
        null,
        null,
        messageFlowType,
        senderName,
        flowLinkType
      );
    }, [
      selectedCustomer,
      fetchTransactions,
      messageFlowType,
      senderName,
      flowLinkType,
    ]);

    const getTransactionStatusByGroupIdAndDocumentType = useCallback(
      async (transaction) => {
        try {
          await fetchTransactions(
            null,
            null,
            transaction.messageGroupId,
            transaction.documentType
          );
        } catch (error) {
          throw new Error(
            `Error fetching transaction status: ${error.message}`
          );
        }
      },
      [fetchTransactions]
    );

    const handleTransactionStatusByGroupId = useCallback(
      (transaction) => {
        getTransactionStatusByGroupIdAndDocumentType(transaction)
          .then((status) => {
            console.log("Transaction Status:", status);
          })
          .catch((error) => {
            console.error("Error fetching transaction status:", error);
          });
      },
      [getTransactionStatusByGroupIdAndDocumentType]
    );

    useEffect(() => {
      if (transactionDetails) {
        navigate("/transactions/status", {
          state: { data: transactionDetails },
        });
      }
    }, [transactionDetails, navigate]);

    useEffect(() => {
      console.log("CustomerTransactionTab props:", {
        selectedCustomer,
        setSelectedCustomer,
      });
    }, [selectedCustomer, setSelectedCustomer]);

    if (transactionsLoading) {
      return <Loading />;
    }

    if (transactionsError) {
      return <ErrorLog errorMessage={transactionsError.message} />;
    }

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords =
      fetchCustomerData?.CustomerEDITrnsactionDatails?.slice(
        indexOfFirstRecord,
        indexOfLastRecord
      );
    const totalPages = Math.ceil(
      (fetchCustomerData?.CustomerEDITrnsactionDatails?.length || 0) /
        recordsPerPage
    );

    const nextPage = () =>
      setCurrentPage((prev) => Math.min(prev + 1, totalPages));
    const prevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
    const setPage = (pageNumber) => setCurrentPage(pageNumber);

    const renderPageNumbers = Paginate(totalPages, currentPage, setPage);

    return (
      <div className="flex-center">
        <div className="tab-content">
          <div className="tab-buttons">
            <div className="dropdown">
              <button
                className={`tab-button ${
                  activeTab === "inbound-tab" ? "active" : ""
                }`}
                onClick={() => handleTabClick("inbound-tab")}
              >
                Inbound EDI
              </button>
              <div className="dropdown-content">
                <button
                  className={`child-tab-button ${
                    activeChildTab === "transactionStatus" ? "active" : ""
                  }`}
                  onClick={() =>
                    handleInboundChildTabClick("transactionStatus")
                  }
                >
                  Transaction Tracking
                </button>
                <button
                  className={`child-tab-button ${
                    activeChildTab === "transactionHistory" ? "active" : ""
                  }`}
                  onClick={() =>
                    handleInboundChildTabClick("transactionHistory")
                  }
                >
                  Transaction History
                </button>
              </div>
            </div>

            <div className="dropdown">
              <button
                className={`tab-button ${
                  activeTab === "outbound-tab" ? "active" : ""
                }`}
                onClick={() => handleTabClick("outbound-tab")}
              >
                Outbound EDI
              </button>
              {activeTab === "outbound-tab" && (
                <div className="dropdown-content">
                  {senderList?.map((name, index) => (
                    <div className="dropdown" key={index}>
                      <button
                        className={`sub-tab-button ${
                          activeOutboundSubTab === name ? "active" : ""
                        }`}
                        onClick={() => handleOutboundSubTabClick(name)}
                      >
                        {name}
                      </button>
                      {renderDropdownContent(
                        name,
                        activeOutboundSubTab,
                        activeSubSubTab,
                        handleSubSubTabClick
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {activeTab === "inbound-tab" && (
            <>
              {activeChildTab === "transactionStatus" && (
                <CustomerTransactionTab
                  selectedCustomer={selectedCustomer}
                  setSelectedCustomer={setSelectedCustomer}
                  fetchTransactionDetails={fetchTransactionDetails}
                  fetchCustomerData={fetchCustomerData}
                  currentRecords={currentRecords}
                  currentPage={currentPage}
                  prevPage={prevPage}
                  nextPage={nextPage}
                  renderPageNumbers={renderPageNumbers}
                  totalPages={totalPages}
                  messageFlowType="Inbound"
                />
              )}
              {activeChildTab === "transactionHistory" && (
                <TransactionHistoryTab
                  searchInput={searchInput}
                  handleTransactionStatusByGroupId={
                    handleTransactionStatusByGroupId
                  }
                  messageFlowType="Inbound"
                  senderName={senderName}
                />
              )}
            </>
          )}

          {activeTab === "outbound-tab" && activeOutboundSubTab && (
            <>
              {activeSubSubTab === "transactionStatus" && (
                <CustomerTransactionTab
                  selectedCustomer={selectedCustomer}
                  setSelectedCustomer={setSelectedCustomer}
                  fetchTransactionDetails={fetchTransactionDetails}
                  fetchCustomerData={fetchCustomerData}
                  currentRecords={currentRecords}
                  currentPage={currentPage}
                  prevPage={prevPage}
                  nextPage={nextPage}
                  renderPageNumbers={renderPageNumbers}
                  totalPages={totalPages}
                  messageFlowType="Outbound"
                />
              )}

              {activeSubSubTab === "transactionHistory" && (
                <TransactionHistoryTab
                  searchInput={searchInput}
                  handleTransactionStatusByGroupId={
                    handleTransactionStatusByGroupId
                  }
                  messageFlowType="Outbound"
                  senderName={senderName}
                />
              )}

              {activeSubSubTab === "transactionStatus" &&
                fetchCustomerData?.CustomerEDITrnsactionDatails?.length ===
                  0 && <div>No transactions available</div>}
            </>
          )}
        </div>
      </div>
    );
  }
);

export default MainTabsComponent;
